export function createState() {
  return {
    hoveredSection: null,
    selectedSection: null,
    fullAnalysisData: null,

    map: null,
    gpxData: null,
    gpxLayer: null,
    highlightLayer: null,
    selectionLayer: null,

    actualPerformance: null,
    comparison: null,
    fileType: null,
    courseData: null
  };
}
